import {Component, OnInit, TemplateRef} from '@angular/core';
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead/public_api';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {TSFuntionService} from '../../services/ts-funtion.service';
import {Router} from '@angular/router';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {DatePipe, DecimalPipe} from '@angular/common';
import * as _ from 'lodash';
import {indexOf} from '@amcharts/amcharts4/.internal/core/utils/Array';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {string} from '@amcharts/amcharts4/core';
import {SWAlertService} from '../../services/swalert.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-manual-updatefi',
  templateUrl: './manual-updatefi.component.html',
  styleUrls: ['./manual-updatefi.component.css']
})
export class ManualUpdatefiComponent implements OnInit {
  // Declare variable
  // Form controll
  sFIDocFrom = new FormGroup({
    sFIDocReqID : new FormControl(''),
    sFIDocReqCode : new FormControl(''),
    sFIDocItemNO : new FormControl(''),
    sFIDoc: new FormControl('', Validators.required),
    sFIDocCoCd : new FormControl(''),
    sFIDocYear : new FormControl('', Validators.required)
  });
  ClearingDocFrom = new FormGroup({
    clearingDocReqID : new FormControl(''),
    clearingReqCode : new FormControl(''),
    clearingItemNO : new FormControl(''),
    clearingDoc: new FormControl('', Validators.required),
    clearingDocCoCd : new FormControl(''),
    clearingDocYear : new FormControl('', Validators.required)
  });
  AdvClearingDocFrom = new FormGroup({
    AdvClearingDocReqID : new FormControl(''),
    AdvClearingReqCode : new FormControl(''),
    AdvClearingItemNO : new FormControl(''),
    AdvClearingDoc: new FormControl('', Validators.required),
    AdvClearingCoCd : new FormControl(''),
    AdvClearingYear : new FormControl('', Validators.required)
  });
  ReceiveDocFrom = new FormGroup({
    ReceiveDocReqID : new FormControl(''),
    ReceiveReqCode : new FormControl(''),
    ReceiveItemNO : new FormControl(''),
    ReceiveDoc: new FormControl('', Validators.required),
    ReceiveCoCd : new FormControl(''),
    ReceiveYear : new FormControl('', Validators.required)
  });
  sValidFIDoc: string = null;
  sValidClearingDoc: string = null;
  sValidAdvClearingDoc: string = null;
  sValidRecieveDoc: string = null;
  nRow: Number = 0;
  // This for modal
  modalRef: BsModalRef;
  // ReqNo.
  _sReqNo: any[] = [];
  IsReqNo = false;
  txtReqNo: string = null;
  sReqNo: any;
  // FI Doc no
  _sFIDoc: any[] = [];
  IsFIDoc = false;
  txtFIDoc: string = null;
  sFIDoc: any;
  nFlagSearch: any = 0;
  // Company
  company: any[] = [];
  settings_com = {};
  CompanyData: any[] = [];
  // ReqType
  ReqType: any[] = [];
  settings_ReqType = {};
  txtReqType: any[] = [];

  // Table Display
  ColumnsData = [
    {
      ColumnName: 'Request ID.',
      Value: 'sRequestID',
      Section: 1,
      show: 'y',
      SortField: 'sRequestID',
      Width: '4%',
      Align: 'center',
      Decimal: 'n',

    },
    {
      ColumnName: 'Request No.',
      Value: 'sRequestCode',
      Section: 1,
      show: 'n',
      SortField: 'sRequestCode',
      Width: '4%',
      Align: 'center',
      Decimal: 'n',

    },
    {
      ColumnName: 'Request Type',
      Value: 'sReqType',
      Section: 1,
      show: 'n',
      SortField: 'sReqType',
      Width: '5%',
      Align: 'center',
      Decimal: 'n',

    },
    {
      ColumnName: 'COCD',
      Value: 'sCompCode',
      Section: 1,
      show: 'y',
      SortField: 'sCompCode',
      Width: '5%',
      Align: 'center',
      Decimal: 'n',

    },
    {
      ColumnName: 'Item No.',
      Value: 'nItemNo',
      Section: 1,
      show: 'y',
      SortField: 'nItemNo',
      Width: '2%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Receipt No.',
      Value: 'sInvoiceNo',
      Section: 1,
      show: 'n',
      SortField: 'sInvoiceNo',
      Width: '3%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Amount',
      Value: 'nIncludeVAT',
      Section: 1,
      show: 'n',
      SortField: 'nIncludeVAT',
      Width: '2%',
      Align: 'center',
      Decimal: 'y',
    },
    {
      ColumnName: 'Cur.',
      Value: 'sCurrency',
      Section: 1,
      show: 'n',
      SortField: 'sCurrency',
      Width: '2%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Description',
      Value: 'sInvoiceDesc',
      Section: 1,
      show: 'n',
      SortField: 'sInvoiceDesc',
      Width: '4%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'FI Doc',
      Value: 'sFIDoc',
      Section: 1,
      show: 'n',
      SortField: 'sFIDoc',
      Width: '5%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'FI Doc Year',
      Value: 'nFIDocYear',
      Section: 1,
      show: 'y',
      SortField: 'nFIDocYear',
      Width: '3%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Clearing Doc',
      Value: 'sClearingDoc',
      Section: 1,
      show: 'n',
      SortField: 'sClearingDoc',
      Width: '5%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Clearing Doc Year',
      Value: 'nClearingDocYear',
      Section: 1,
      show: 'y',
      SortField: 'nClearingDocYear',
      Width: '3%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Advance Clearing Doc',
      Value: 'sAdvClearingDoc',
      Section: 1,
      show: 'n',
      SortField: 'sAdvClearingDoc',
      Width: '5%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Advance Clearing Doc Year',
      Value: 'nAdvClearingDocYear',
      Section: 1,
      show: 'y',
      SortField: 'nAdvClearingDocYear',
      Width: '3%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Receive Doc',
      Value: 'sRecieveDoc',
      Section: 1,
      show: 'n',
      SortField: 'sRecieveDoc',
      Width: '5%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Receive Doc Year',
      Value: 'nRecieveDocYear',
      Section: 1,
      show: 'y',
      SortField: 'nRecieveDocYear',
      Width: '3%',
      Align: 'center',
      Decimal: 'n',
    },
    ];
  IsCompanyFilter = false;
  IsLinkStatus = false;
  ColumnsSelected: any[] = [];
  IsHeaderSort = '';
  SortDirection = '';
  SortICO = 'fas fa-sort';
  IcoSort = 'fas fa-sort';
  IcoSortDesc = 'fas fa-sort-up';
  IcoSortAsc = 'fas fa-sort-down';
  _ArrDataFirst = [];
  _ArrDataBind = [];
  sDetailData = '';
  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      {sValue: 10},
      {sValue: 20},
      {sValue: 50},
      {sValue: 100}
    ]
  };
  _ArrData: any;
  _FiReqType: any;
  _ClearingReqType: any;
  _AdvClearingReqType: any;
  _ReceiveReqType: any;
  isDisabledSaveFIDoc = true;
  isDisabledSaveClearingDoc = true;
  isDisabledSaveAdvClearingDoc = true;
  isDisabledSaveReceiveDoc = true;
  isDuplicate = false;
  constructor(private http: HttpClient,
              private System: TSFuntionService,
              private _decimalPipe: DecimalPipe,
              private modalService: BsModalService,
              private formBuilder: FormBuilder,
              private SW: SWAlertService
  ) { }

 async ngOnInit() {
    this.getReqNo();
    this.getReqType();
    this.getCompany();
    this.getFiNo();
    this.ColumnsSelected = this.ColumnsData.filter(e => e.show === 'n');
    this.settings_com = {
      singleSelection: false,
      idField: 'COMPANY_CODE',
      textField: 'COMPANY_NAME',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.settings_ReqType = {
      singleSelection: false,
      idField: 'nReqType',
      textField: 'sReqType',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this._ArrDataFirst = [];
   const ua = this.System.GetUserStorage();
   if (ua) {
     this.IsCompanyFilter = (ua.nRole === 2);
     if (this.IsCompanyFilter) {
       this.CompanyData = [];
       ua.lstCompCode.forEach(f =>
         this.CompanyData.push({COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName})
       );
     }
     await this.getControlInput();
     await this.GetData(0);
   }

   const This = this;

   this.sFIDocFrom.controls['sFIDoc'].valueChanges.subscribe(value => {
     if (value != null) {
       if (value.length >= 2) {
         if (this.sValidFIDoc != null && this.sValidFIDoc != '') {
           const sArr = this.sValidFIDoc.split(",");
           if (!sArr.includes(value.substring(0, 2))) {
             this.SW.SwAlert.Warning('FI Doc Format Invalid.', `Please Start With ${this.sValidFIDoc}`, function () { This.sFIDocFrom.controls.sFIDoc.setValue('') });
           }
         }
       }
     }
   });

   this.ClearingDocFrom.controls['clearingDoc'].valueChanges.subscribe(value => {
     if (value != null) {
       if (value.length >= 2) {
         if (this.sValidClearingDoc != null && this.sValidClearingDoc != '') {
           const sArr = this.sValidClearingDoc.split(",");
           if (!sArr.includes(value.substring(0, 2))) {
             this.SW.SwAlert.Warning('Clearing Doc Format Invalid.', `Please Start With ${this.sValidClearingDoc}`, function () { This.ClearingDocFrom.controls.clearingDoc.setValue('') });
           }
         }
       }
     }
   });

   this.AdvClearingDocFrom.controls['AdvClearingDoc'].valueChanges.subscribe(value => {
     if (value != null) {
       if (value.length >= 2) {
         if (this.sValidAdvClearingDoc != null && this.sValidAdvClearingDoc != '') {
           const sArr = this.sValidAdvClearingDoc.split(",");
           if (!sArr.includes(value.substring(0, 2))) {
             this.SW.SwAlert.Warning('Advance Clearing Doc Format Invalid.', `Please Start With ${this.sValidAdvClearingDoc}`, function () { This.AdvClearingDocFrom.controls.AdvClearingDoc.setValue('') });
           }
         }
       }
     }
   });

   this.ReceiveDocFrom.controls['ReceiveDoc'].valueChanges.subscribe(value => {
     if (value != null) {
       if (value.length >= 2) {
         if (this.sValidRecieveDoc != null && this.sValidRecieveDoc != '') {
           const sArr = this.sValidRecieveDoc.split(",");
           if (!sArr.includes(value.substring(0, 2))) {
             this.SW.SwAlert.Warning('Recieve Doc Format Invalid.', `Please Start With ${this.sValidRecieveDoc}`, function () { This.ReceiveDocFrom.controls.ReceiveDoc.setValue('') });
           }
         }
       }
     }
   });

 }

  typeaheadOnBlur(event: TypeaheadMatch, index) {
    switch (index) {
      case 'txtReqNo':
        if (this.IsReqNo && this.txtReqNo) {
          this.sReqNo = null;
        } else {
          const sReqNo = this.txtReqNo.trim();
          const CHK = this._sReqNo.filter(f => f.sRequestCode === sReqNo );
          if (CHK.length > 0) {
            this.onSelect(event, index);
          } else {
            this.txtReqNo = '';
          }
        }
        break;
      case 'txtFIDoc':
        if (this.IsFIDoc && this.txtFIDoc) {
          this.sFIDoc = null;
        } else {
          const sFIDoc = this.txtFIDoc.trim();
          const CHK = this._sFIDoc.filter(f => f.sFIDoc === sFIDoc);
          if (CHK.length > 0) {
            this.onSelect(event, index);
          }
        }
        break;
    }
  }
  onSelect(event: TypeaheadMatch, index) {
    switch (index) {
      case 'txtReqNo':
        this.sReqNo = event.item.value;
        break;
      case 'txtFIDoc':
        this.sFIDoc = event.item.value;
        break;
    }
  }
  onSelectAll_com(item: any) {
    this.CompanyData = item;
  }
  onDeselect_com(item: any) {
    this.CompanyData = item;
  }
  onSelectAll_ReqType(item: any) {
    this.txtReqType = item;
  }
  onDeselect_ReqType(item: any) {
    this.txtReqType = item;
  }
  getCompany() {
    this.http.get<any>(this.System.SiteName + 'api/ManualUpdateFi/GetCompany').subscribe(res => {
      if (res) {
        this.company = res;
      }
    });
  }
  getReqType() {
    this.http.get<any>(this.System.SiteName + 'api/Search/Getpaytype2').toPromise().then(res => {
      if (res) {
        this.ReqType = res;
      }
    });
  }
  getReqNo() {
    this.http.get<any>(this.System.SiteName + 'api/ManualUpdateFi/GetReqNo').toPromise().then(res => {
      this.sReqNo = res;
      this._sReqNo = res;
    });
  }

  getFiNo() {
    this.http.get<any>(this.System.SiteName + 'api/ManualUpdateFi/GetFINo').toPromise().then(res => {
      this.sFIDoc = res;
      this._sFIDoc = res;
    });
  }

  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      } else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this._ArrData = _.orderBy(this._ArrData, [SortField], [this.SortDirection]);
      this.BindDataTable();
    }
  }
  _RowResult(decimal, value) {
    return (decimal === 'y' && value !== null) ? this._ConvertToDecimal(value) : value;
  }
  _ConvertToDecimal(sVal) {
    const NoComma = (sVal + '').replace(/,/g, ''); // ตัด Comma ออก
    const Data = this._decimalPipe.transform(NoComma, '1.2-2');
    return Data;
  }
  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }
  BindDataTable() {
    this.OptionGrid.nTotalItem = this._ArrData.length;
    const nPageSize = this.System.ParseIntToZero(this.OptionGrid.nPageSize);
    const nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * nPageSize;
    const nEndIndex_Take = nPageSize;
    this._ArrDataBind = [];
    this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({}, val)));
    this._ArrDataBind = this._ArrDataBind.splice(nStartIndex_Take, nEndIndex_Take);
    const nStartItemPage = nStartIndex_Take + 1;
    const nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData = 'Showing ' + nStartItemPage + ' to ' + nLastItemPage + ' of ' + this._ArrData.length + ' Rows';
    this.System.UnBlockUI();
    // this.cbExportAll_Checked();
  }
  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataTable();
    });
  }
 async ClearData() {
    this.sReqNo = null;
    this.CompanyData = [];
    this.txtReqNo = null;
    this.txtReqType = [];
    this.txtFIDoc = null;
    this._ArrData = [];
    this._ArrDataBind = [];
    const ua = this.System.GetUserStorage();
    if (ua) {
      this.IsCompanyFilter = (ua.nRole === 2);
      if (this.IsCompanyFilter) {
        this.CompanyData = [];
        ua.lstCompCode.forEach(f =>
          this.CompanyData.push({COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName})
        );
      }
      await this.GetData(0);
    }

    this.OptionGrid.nCurrentPage = 1;
    this.BindDataTable();
  }
  async GetData(search) {
    this.nFlagSearch = search;
    this._ArrDataFirst = [];
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const data = {
      search: search,
      sReqNo: search === 1 ? this.txtReqNo : '',
      arrCompany : this.CompanyData,
      arrReqType : this.txtReqType,
      sFIDoc : search === 1 ? this.txtFIDoc : ''
    };

    const ITEM = JSON.stringify(data);
     this.http.post(this.System.SiteName + 'api/ManualUpdateFi/searchData', ITEM,
      // tslint:disable-next-line:no-shadowed-variable
      {headers, responseType: 'json'}).toPromise().then((data: Response) => {
        if (data) {
          const item = Object.values(data);
          if (item.length > 0) {
            const result = [];
            for (let x = 0; x < item.length; x++) {
              result.push({ ...data[x], IsChecked: false });
            }
            if (search === 0) {
              for ( let x = 0; x < result.length; x++) {
                const checkType = ['y', 'y', 'y', 'y'];
                 if (this._FiReqType.filter(f => f === result[x]['sReqTypeNo']).length > 0 && !result[x]['sFIDoc']) {
                   checkType[0] = 'n';
                 }
                if (this._ClearingReqType.filter(f => f === result[x]['sReqTypeNo']).length > 0 && !result[x]['sClearingDoc']) {
                  checkType[1] = 'n';
                }
                if (this._AdvClearingReqType.filter(f => f === result[x]['sReqTypeNo']).length > 0
                  && !result[x]['sAdvClearingDoc']) {
                  checkType[2] = 'n';
                }
                if (this._ReceiveReqType.filter(f => f === result[x]['sReqTypeNo']).length > 0 && !result[x]['sRecieveDoc']) {
                  checkType[3] = 'n';
                }
               //if (checkType.filter(f => f === 'y').length === 4) {
               //   result.splice(x, 1);
               //   x -= 1;
               //}
              }

            }
            this._ArrDataFirst = result;
            this._ArrData = result;
          } else {
            this._ArrData = [];
          }
        } else {
          this._ArrData = [];
        }
      this.BindDataTable();
    });
  }
  checkToShowTable() {

  }
  checkToHideReqNo(index) {
    let result = this._ArrDataBind[index]['sRequestCode'];
    if (index > 0) {
      const lastP = index - 1;
      if (this._ArrDataBind[lastP]['sRequestCode'] === this._ArrDataBind[index]['sRequestCode']) {
        result = '';
      }
    }
    return result;
  }

  checkToShowIcon(index) {
    let isShow = false;
    const arr = this._ArrDataBind.filter(f => f.sRequestID === this._ArrDataBind[index].sRequestID);
    if (this.checkToHideReqNo(index) === '') {
      isShow = false;
    }
    else if (arr.length > 0) {
      isShow = arr[0].nStatusID > 9
    }
    

    return isShow;
  }

  checkToHideCheckbox(index) {
    let isShow = false;
    const arr = this._ArrDataBind.filter(f => f.sRequestID === this._ArrDataBind[index].sRequestID);
    if (arr.length === 1) {
      isShow = this.checkField(arr[0], index);
      if (!isShow) {
        return false;
      }
    } else if (this.checkToHideReqNo(index) !== '') {
      for (let i = 0; i < arr.length; i++) {
        isShow = this.checkField(arr[i], index + i);
        if (!isShow) {
          return false;
        }
      }
    }

    return isShow;
  }

  checkField(arr, index) {
    //const fieldCheck = ['sFIDoc', 'sClearingDoc', 'sAdvClearingDoc', 'sRecieveDoc'];
    const fieldCheck = ['sFIDoc'];
    let check = false;
    for (let i = 0; i < fieldCheck.length; i++) {
      const field = fieldCheck[i];
      if (!this.checkToHideField(field, index) || (arr[field] != null && arr[field] !== '')) {
        check = true;
      } else {
        return false;
      }
    }
    return check;
  }

  checkToHideField(field, index) {
    if (field === 'sFIDoc' && this._FiReqType) {
      const result = this._FiReqType.indexOf(this._ArrDataBind[index]['sReqTypeNo']);
      if (result > -1) {
        return true;
      }
    }
    if (field === 'sClearingDoc' && this._ClearingReqType) {
      const result = this._ClearingReqType.indexOf(this._ArrDataBind[index]['sReqTypeNo']);
      if (result > -1) {
        return true;
      }
    }
    if (field === 'sAdvClearingDoc' && this._AdvClearingReqType) {
      const result = this._AdvClearingReqType.indexOf(this._ArrDataBind[index]['sReqTypeNo']);
      if (result > -1) {
        return true;
      }
    }
    if (field === 'sRecieveDoc' && this._ReceiveReqType) {
      const result = this._ReceiveReqType.indexOf(this._ArrDataBind[index]['sReqTypeNo']);
      if (result > -1) {
        return true;
      }
    }
  return false;
  }

  async getControlInput() {
    await this.http.get<any>(this.System.SiteName + 'api/ManualUpdateFi/FiReqType').toPromise().then(res => {
      if (res) {
        const data = res[0]['sValueText'].split(',');
        const result = [];
        for (let x = 0; x < data.length; x++) {
          // tslint:disable-next-line:radix
          result.push(parseInt(data[x]));
        }
        this._FiReqType = result;
      }
    });
    await this.http.get<any>(this.System.SiteName + 'api/ManualUpdateFi/ClearingReqType').toPromise().then(res => {
      if (res) {
        const data = res[0]['sValueText'].split(',');
        const result = [];
        for (let x = 0; x < data.length; x++) {
          // tslint:disable-next-line:radix
          result.push(parseInt(data[x]));
        }
        this._ClearingReqType = result;
      }
    });
    await this.http.get<any>(this.System.SiteName + 'api/ManualUpdateFi/AdvClearingReqType').toPromise().then(res => {
      if (res) {
        const data = res[0]['sValueText'].split(',');
        const result = [];
        for (let x = 0; x < data.length; x++) {
          // tslint:disable-next-line:radix
          result.push(parseInt(data[x]));
        }
        this._AdvClearingReqType = result;
      }
    });
    await this.http.get<any>(this.System.SiteName + 'api/ManualUpdateFi/ReceiveReqType').toPromise().then(res => {
      if (res) {
        const data = res[0]['sValueText'].split(',');
        const result = [];
        for (let x = 0; x < data.length; x++) {
          // tslint:disable-next-line:radix
          result.push(parseInt(data[x]));
        }
        this._ReceiveReqType = result;
      }
    });
  }

  checkYearValue(value) {
    const d = new Date();
    let year = d.getFullYear();
    if (value != "" && value != undefined) {
      year = value
    }
    return year
  }

  OpensFIDoc(templateFiDoc: TemplateRef<any>, numRow, value) {
    this.sValidFIDoc = value;
    this.nRow = numRow;
    this.sFIDocFrom.get('sFIDocReqID').setValue(this._ArrDataBind[numRow]['sRequestID']);
    this.sFIDocFrom.get('sFIDocReqCode').setValue(this._ArrDataBind[numRow]['sRequestCode']);
    this.sFIDocFrom.get('sFIDocItemNO').setValue(this._ArrDataBind[numRow]['nItemNo']);
    this.sFIDocFrom.controls.sFIDoc.setValue(this._ArrDataBind[numRow]['sFIDoc']);
    this.sFIDocFrom.controls.sFIDocCoCd.setValue(this._ArrDataBind[numRow]['sCompCode']);
    //this.sFIDocFrom.controls.sFIDocYear.setValue(this._ArrDataBind[numRow]['nFIDocYear']);
    this.sFIDocFrom.controls.sFIDocYear.setValue(this.checkYearValue(this._ArrDataBind[numRow]['nFIDocYear']));
    this.modalRef = this.modalService.show(
      templateFiDoc,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }
  OpensClearingDoc(templateClearingDoc: TemplateRef<any>, numRow, value) {
    this.sValidClearingDoc = value;
    this.nRow = numRow;
    this.ClearingDocFrom.get('clearingDocReqID').setValue(this._ArrDataBind[numRow]['sRequestID']);
    this.ClearingDocFrom.get('clearingReqCode').setValue(this._ArrDataBind[numRow]['sRequestCode']);
    this.ClearingDocFrom.get('clearingItemNO').setValue(this._ArrDataBind[numRow]['nItemNo']);
    this.ClearingDocFrom.controls.clearingDoc.setValue(this._ArrDataBind[numRow]['sClearingDoc']);
    this.ClearingDocFrom.controls.clearingDocCoCd.setValue(this._ArrDataBind[numRow]['sCompCode']);
    //this.ClearingDocFrom.controls.clearingDocYear.setValue(this._ArrDataBind[numRow]['nClearingDocYear']);
    this.ClearingDocFrom.controls.clearingDocYear.setValue(this.checkYearValue(this._ArrDataBind[numRow]['nClearingDocYear']));
    this.modalRef = this.modalService.show(
      templateClearingDoc,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }
  OpensAdvClearingDoc(templateAdvClearingDoc: TemplateRef<any>, numRow, value) {
    this.sValidAdvClearingDoc = value;
    this.nRow = numRow;
    this.AdvClearingDocFrom.get('AdvClearingDocReqID').setValue(this._ArrDataBind[numRow]['sRequestID']);
    this.AdvClearingDocFrom.get('AdvClearingReqCode').setValue(this._ArrDataBind[numRow]['sRequestCode']);
    this.AdvClearingDocFrom.get('AdvClearingItemNO').setValue(this._ArrDataBind[numRow]['nItemNo']);
    this.AdvClearingDocFrom.controls.AdvClearingDoc.setValue(this._ArrDataBind[numRow]['sAdvClearingDoc']);
    this.AdvClearingDocFrom.controls.AdvClearingCoCd.setValue(this._ArrDataBind[numRow]['sCompCode']);
    //this.AdvClearingDocFrom.controls.AdvClearingYear.setValue(this._ArrDataBind[numRow]['nAdvClearingDocYear']);
    this.AdvClearingDocFrom.controls.AdvClearingYear.setValue(this.checkYearValue(this._ArrDataBind[numRow]['nAdvClearingDocYear']));
    this.modalRef = this.modalService.show(
      templateAdvClearingDoc,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }
  OpensReceiveDoc(templateReceiveDoc: TemplateRef<any>, numRow, value) {
    this.sValidRecieveDoc = value;
    this.nRow = numRow;
    this.ReceiveDocFrom.get('ReceiveDocReqID').setValue(this._ArrDataBind[numRow]['sRequestID']);
    this.ReceiveDocFrom.get('ReceiveReqCode').setValue(this._ArrDataBind[numRow]['sRequestCode']);
    this.ReceiveDocFrom.get('ReceiveItemNO').setValue(this._ArrDataBind[numRow]['nItemNo']);
    this.ReceiveDocFrom.controls.ReceiveDoc.setValue(this._ArrDataBind[numRow]['sRecieveDoc']);
    this.ReceiveDocFrom.controls.ReceiveCoCd.setValue(this._ArrDataBind[numRow]['sCompCode']);
    //this.ReceiveDocFrom.controls.ReceiveYear.setValue(this._ArrDataBind[numRow]['nRecieveDocYear']);
    this.ReceiveDocFrom.controls.ReceiveYear.setValue(this.checkYearValue(this._ArrDataBind[numRow]['nRecieveDocYear']));
    this.modalRef = this.modalService.show(
      templateReceiveDoc,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }
  isFieldValid(form, _Field: string) {
    if (form === 'sFIDocFrom') {
      return !this.sFIDocFrom.get(_Field).valid && this.sFIDocFrom.get(_Field).touched;
    }
    if (form === 'ClearingDocFrom') {
      return !this.ClearingDocFrom.get(_Field).valid && this.ClearingDocFrom.get(_Field).touched;
    }
    if (form === 'AdvClearingDocFrom') {
      return !this.AdvClearingDocFrom.get(_Field).valid && this.AdvClearingDocFrom.get(_Field).touched;
    }
    if (form === 'ReceiveDocFrom') {
      return !this.ReceiveDocFrom.get(_Field).valid && this.ReceiveDocFrom.get(_Field).touched;
    }
  }
  displayFieldCss(form, _Field: string) {
    return {
      'has-error': this.isFieldValid(form, _Field),
      'has-feedback': this.isFieldValid(form, _Field)
    };
  }
  checkSaveMinimum(form, _Field: string, _Field2: string) {
   
    if (form === 'sFIDocFrom') {
      if (this.sFIDocFrom.get(_Field).value && this.sFIDocFrom.get(_Field2).value) {
        const doc = this.sFIDocFrom.get(_Field).value;
        const year = this.sFIDocFrom.get(_Field2).value.toString();
        if (doc.length === 10 && year.length === 4) {
          this.isDisabledSaveFIDoc = false;
        } else {
          this.isDisabledSaveFIDoc = true;
        }
      }
      else {
        this.isDisabledSaveFIDoc = true;
      }
    }
    if (form === 'ClearingDocFrom') {
      if (this.ClearingDocFrom.get(_Field).value && this.ClearingDocFrom.get(_Field2).value) {
        const doc = this.ClearingDocFrom.get(_Field).value;
        const year = this.ClearingDocFrom.get(_Field2).value.toString();
        if (doc.length === 10 && year.length === 4) {
          this.isDisabledSaveClearingDoc = false;
        } else {
          this.isDisabledSaveClearingDoc = true;
        }
      }
      else {
        this.isDisabledSaveClearingDoc = true;
      }
    }
    if (form === 'AdvClearingDocFrom') {
      if (this.AdvClearingDocFrom.get(_Field).value && this.AdvClearingDocFrom.get(_Field2).value) {
        const doc = this.AdvClearingDocFrom.get(_Field).value;
        const year = this.AdvClearingDocFrom.get(_Field2).value.toString();
        if (doc.length === 10 && year.length === 4) {
          this.isDisabledSaveAdvClearingDoc = false;
        } else {
          this.isDisabledSaveAdvClearingDoc = true;
        }
      }
      else {
        this.isDisabledSaveAdvClearingDoc = true;
      }
    }
    if (form === 'ReceiveDocFrom') {
      if (this.ReceiveDocFrom.get(_Field).value && this.ReceiveDocFrom.get(_Field2).value) {
        const doc = this.ReceiveDocFrom.get(_Field).value;
        const year = this.ReceiveDocFrom.get(_Field2).value.toString();
        if (doc.length === 10 && year.length === 4) {
          this.isDisabledSaveReceiveDoc = false;
        } else {
          this.isDisabledSaveReceiveDoc = true;
        }
      }
      else {
        this.isDisabledSaveReceiveDoc = true;
      }
    }
    return '';
  }
  async saveDoc(form) {
    let isValid = true;
    const This = this;
    const nRow :any = This.nRow;
    const toSave = {
      formN: form,
      reqID: '',
      reqCode: '',
      itemNo: '',
      comCode: '',
      docNo : '',
      year : null
    };
    if (form === 'sFIDocFrom') {
      // tslint:disable-next-line:radix
      if (this.sFIDocFrom.controls.sFIDocYear.value !== null && Number.isInteger(parseInt(this.sFIDocFrom.controls.sFIDocYear.value)) ) {
        toSave.reqID = this.sFIDocFrom.controls.sFIDocReqID.value;
        toSave.reqCode = this.sFIDocFrom.controls.sFIDocReqCode.value;
        toSave.itemNo = this.sFIDocFrom.controls.sFIDocItemNO.value;
        toSave.docNo = this.sFIDocFrom.controls.sFIDoc.value;
        toSave.comCode = this.sFIDocFrom.controls.sFIDocCoCd.value;
        // tslint:disable-next-line:radix
        toSave.year = parseInt(this.sFIDocFrom.controls.sFIDocYear.value);
      } else {
        isValid = false;
        this.sFIDocFrom.get('sFIDocYear').markAsTouched({ onlySelf: true });
      }
    }
    if (form === 'ClearingDocFrom') {
      if (
        this.ClearingDocFrom.controls.clearingDocYear.value !== null
        // tslint:disable-next-line:radix
        && Number.isInteger(parseInt(this.ClearingDocFrom.controls.clearingDocYear.value))
      ) {
        toSave.reqID = this.ClearingDocFrom.controls.clearingDocReqID.value;
        toSave.reqCode = this.ClearingDocFrom.controls.clearingReqCode.value;
        toSave.itemNo = this.ClearingDocFrom.controls.clearingItemNO.value;
        toSave.docNo = this.ClearingDocFrom.controls.clearingDoc.value;
        toSave.comCode = this.ClearingDocFrom.controls.clearingDocCoCd.value;
        // tslint:disable-next-line:radix
        toSave.year = parseInt(this.ClearingDocFrom.controls.clearingDocYear.value);
      } else {
        isValid = false;
        this.ClearingDocFrom.get('clearingDocYear').markAsTouched({ onlySelf: true });
      }
    }
    if (form === 'AdvClearingDocFrom') {
      if (
        this.AdvClearingDocFrom.controls.AdvClearingYear.value !== null
        // tslint:disable-next-line:radix
        && Number.isInteger(parseInt(this.AdvClearingDocFrom.controls.AdvClearingYear.value))
      ) {
        toSave.reqID = this.AdvClearingDocFrom.controls.AdvClearingDocReqID.value;
        toSave.reqCode = this.AdvClearingDocFrom.controls.AdvClearingReqCode.value;
        toSave.itemNo = this.AdvClearingDocFrom.controls.AdvClearingItemNO.value;
        toSave.docNo = this.AdvClearingDocFrom.controls.AdvClearingDoc.value;
        toSave.comCode = this.AdvClearingDocFrom.controls.AdvClearingCoCd.value;
        // tslint:disable-next-line:radix
        toSave.year = parseInt(this.AdvClearingDocFrom.controls.AdvClearingYear.value);
      } else {
        isValid = false;
        this.AdvClearingDocFrom.get('AdvClearingYear').markAsTouched({ onlySelf: true });
      }
    }
    if (form === 'ReceiveDocFrom') {
      if (
        this.ReceiveDocFrom.controls.ReceiveYear.value !== null
        // tslint:disable-next-line:radix
        && Number.isInteger(parseInt(this.ReceiveDocFrom.controls.ReceiveYear.value))
      ) {
        toSave.reqID = this.ReceiveDocFrom.controls.ReceiveDocReqID.value;
        toSave.reqCode = this.ReceiveDocFrom.controls.ReceiveReqCode.value;
        toSave.itemNo = this.ReceiveDocFrom.controls.ReceiveItemNO.value;
        toSave.docNo = this.ReceiveDocFrom.controls.ReceiveDoc.value;
        toSave.comCode = this.ReceiveDocFrom.controls.ReceiveCoCd.value;
        // tslint:disable-next-line:radix
        toSave.year = parseInt(this.ReceiveDocFrom.controls.ReceiveYear.value);
      } else {
        isValid = false;
        this.ReceiveDocFrom.get('ReceiveYear').markAsTouched({ onlySelf: true });
      }
    }
    if (isValid) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      const ITEM = JSON.stringify(toSave);
      await this.http.post(this.System.SiteName + 'api/ManualUpdateFi/CheckDuplicate', ITEM,
        // tslint:disable-next-line:no-shadowed-variable
        {headers, responseType: 'json'}).toPromise().then((data: Response) => {
        const item = Object.values(data);
        if (item.length > 0) {
          //if (item[0]['Found'] > 0) {
          //  this.isDuplicate = true;
          //} else {
          //  this.isDuplicate = false;
          //}
          this.isDuplicate = false;
        }
      });
       if (this.isDuplicate === false) {
        this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Save, function () {
          This.System.BlockUI();
          This.http.post(This.System.SiteName + 'api/ManualUpdateFi/saveData', ITEM, {
            headers,
            responseType: 'text' ,
          }).subscribe(result => {
            This.System.UnBlockUI();
            if (result === 'Success') {
              This.SW.SwAlert.Success(This.SW.BoxMsg.Title_Success, 'Data is already saved.', function () {
                const ua = This.System.GetUserStorage();
                if (This.txtReqNo || This.txtFIDoc || (This.CompanyData && This.CompanyData[0]['COMPANY_CODE'] !== ua.lstCompCode[0]['sCompCode'] || This.CompanyData.length > 1)
                  || (This.txtReqType && This.txtReqType.length > 0)) {
                  This.GetData(1);
                } else {
                  This.GetData(0);
                }
              });
              This.sFIDocFrom.reset();
              This.ClearingDocFrom.reset();
              This.AdvClearingDocFrom.reset();
              This.ReceiveDocFrom.reset();
              This.modalRef.hide();
              if (form === 'sFIDocFrom') This._ArrDataBind[nRow]['sFIDoc'] = toSave.docNo
              if (form === 'ClearingDocFrom') This._ArrDataBind[nRow]['sClearingDoc'] = toSave.docNo
              if (form === 'AdvClearingDocFrom') This._ArrDataBind[nRow]['sAdvClearingDoc'] = toSave.docNo
              if (form === 'ReceiveDocFrom') This._ArrDataBind[nRow]['sRecieveDoc'] = toSave.docNo
              

            }
          });
        }, function () {
          Swal.close();
        });
      }
    }
  }
  ExportExcel() {

    const manualFiHeader = [];
    const manualFiBody = [];
    let mergeData = {};
    for (let x = 0; x < this.ColumnsData.length; x++) {
      manualFiHeader.push({
        ColumnName: this.ColumnsData[x].ColumnName,
        Value: this.ColumnsData[x].Value,
        Align: this.ColumnsData[x].Align,
        Decimal: this.ColumnsData[x].Decimal
      });
    }
    const prepareBody = [];
    let dataList = {};
    for (let x = 0; x < this._ArrData.length; x++) {
      dataList = this._ArrData[x];
      prepareBody.push(dataList);
    }
    for (const _item of prepareBody) {
      const obj = {};
      for (const tdData of manualFiHeader) {
        obj[tdData.Value] = (
          (_item[tdData.Value] === undefined) ||
          (_item[tdData.Value] === '') ||
          (_item[tdData.Value] === null)
        ) ? null : _item[tdData.Value];
      }

      manualFiBody.push(obj);
    }
    mergeData = {
      manualFiHeader,
      manualFiBody
    };
    const prepareToRequest = [];
    prepareToRequest.push(mergeData);
    const Data = JSON.stringify(prepareToRequest);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    this.http.post(this.System.SiteName + 'api/ManualUpdateFi/ManualFiExportExcel', Data, {
      headers,
      responseType: 'arraybuffer'
    }).subscribe(res => {
      const blob = new Blob([res], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      this.save(blob, 'Update_FIDoc.xlsx');
    });
  }
  save(blob, fileName) {
    if (window.navigator.msSaveOrOpenBlob) { // For IE:
      navigator.msSaveBlob(blob, fileName);
    } else { // For other browsers:
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);
    }
  }

  cbExport(item, sRequestID) {
    // เก็บไว้ Save
    const DATA = this._ArrDataFirst.filter(f => f.sRequestID === sRequestID);
    if (DATA) {
      DATA[0].IsChecked = item.target.checked;
    }

    // แก้ไขข้อมูลผ่าน Array ที่ใช้แสดง Grid
    const DATA_TABLE = this._ArrDataBind.filter(f => f.sRequestID === sRequestID);
    if (DATA_TABLE) {
      DATA_TABLE[0].IsChecked = item.target.checked;
    }

    // แก้ไขข้อมูลผ่าน Array ที่มาจาก Database
    const DATA_BY_BASE = this._ArrData.filter(f => f.sRequestID === sRequestID);
    if (DATA_BY_BASE) {
      DATA_BY_BASE[0].IsChecked = item.target.checked;
    }

  }

  Confirm() {
    const This = this;
    const CheckData = this._ArrDataFirst.filter(f => f.IsChecked === true);
    if (CheckData.length > 0) {
      this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, 'Do you want to submit FI Doc?', function () {
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });

        const Dataexport = JSON.stringify(This._ArrDataFirst);
        This.http.post(This.System.SiteName + 'api/ManualUpdateFi/Save', Dataexport, { headers, responseType: 'text' }).subscribe(s => {
          if (s === 'Success') {
            This.SW.SwAlert.Success(This.SW.BoxMsg.Title_Success, This.SW.BoxMsg.Desc_Success_Confirm, function () {
              This.GetData(This.nFlagSearch)
            });
          } else {
            this.SW.SwAlert.Warning(This.SW.BoxMsg.Title_Warning, s, function () { });
          }
        });
      }, function () { });
    } else {
      this.SW.SwAlert.Warning(This.SW.BoxMsg.Title_Warning, This.SW.BoxMsg.Desc_CheckBox_Waring_Update_FI_Doc, function () { });
    }
  }
  clearDisplayError() {
    this.sFIDocFrom.reset();
    this.ClearingDocFrom.reset();
    this.AdvClearingDocFrom.reset();
    this.ReceiveDocFrom.reset();
    this.isDuplicate = false;
    this.modalRef.hide();
  }

  isNumberKey(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }

}
